import Vue from "vue";
import VueRouter from "vue-router";
// import vClickOutside from 'v-click-outside'
import VueMeta from "vue-meta";

import Home from "@/views/Home";
import ToolTip from "@/views/ToolTip";
// import Park from '@/views/Park'
// import ParkDayuse from "@/views/ParkDayuse";
import ParkDayuse from "@/views/NewParkDayuse";
import Camping from "@/views/Camping";
import InfoGraphic from "@/views/Infographic";
import PageNotFound from "@/views/PageNotFound";
import PlateUpdate from "@/views/PlateUpdate";
import PlateUpdate2 from "@/views/PlateUpdate2";
import CheckExpiration from "../views/CheckExpiration.vue";
import PassHelp from "@/views/PassHelp.vue";
import DeepLink from "@/views/DeepLink.vue";

// EVENTS
// import BisonInfo from "@/views/events/NewBison/BisonInfo";
// import BisonWaiver from "@/views/events/NewBison/BisonWaiver.vue";
import BisonWaitlist from "@/views/events/NewBison/BisonWaitlist.vue";
import Thankyou from "@/views/events/NewBison/Thankyou.vue";
import FantasyAtTheBay from "@/views/events/FantasyAtTheBay";
import FantasyDates from "@/views/events/fantasyDates/FantasyDates";
import dGlasses from "@/views/events/fantasyDates/3dGlasses";
import FishingChallenge from "@/views/events/FishingChallenge";
import QuailTriathlon from "@/views/events/QuailTriathlon";
import DiscGolf from "@/views/events/DiscGolf";
// import MoonWalk from "@/views/events/MoonWalk";
// import MoonWalkJune from "@/views/events/moonWalkDates/June";
// import MoonWalkJuly from "@/views/events/moonWalkDates/July";
// import MoonWalkAugust from "@/views/events/moonWalkDates/August";
// import MoonWalkSeptember from "@/views/events/moonWalkDates/September";
// import MoonWalkOctober from "@/views/events/moonWalkDates/October";
// import MoonWalkWaiver from "@/views/events/moonWalkDates/MoonWalkWaiver";
// import CarShow from "@/views/events/carShow/CarShow";
// import CarShowWaiver from "@/views/events/carShow/carShowWaiver";
import StarvationSpecies from "@/views/events/StarvationSpecies/StarvationSpecies";
import StarvationSpeciesWaiver from "@/views/events/StarvationSpecies/StarvationSpeciesWaiver";
import Moonlit from "@/views/events/moonlit/Moonlit";
import MoonlitWaiver from "@/views/events/moonlit/MoonlitWaiver";

// import GroupFire from "@/views/events/GroupFire";
import Brad from "@/views/events/Brad";
import GroupFireOct7 from "@/views/events/GroupFireDates/Oct7th";
import GroupFireOct20 from "@/views/events/GroupFireDates/Oct20th";
import GroupFireOct27 from "@/views/events/GroupFireDates/Oct27th";
import HikeGSL from "@/views/events/HikeGSL";
import Store from "@/views/Store";
import Mirabilite2023 from "@/views/events/Mirabilite2023";
import MirabileiteDates from "@/views/events/mirabiliteDates/MirabiliteDates";
import MirabiliteJan14 from "@/views/events/mirabiliteDates/Jan14";
import MirabiliteJan15 from "@/views/events/mirabiliteDates/Jan15";
import MirabiliteJan16 from "@/views/events/mirabiliteDates/Jan16";
import MirabiliteJan21 from "@/views/events/mirabiliteDates/Jan21";
import MirabiliteJan22 from "@/views/events/mirabiliteDates/Jan22";
import Eggstrav from "@/views/events/EasterEastCanyon";
import Prehistoric from "@/views/events/PrehistoricStory";
import PaintNight from "@/views/events/PaintNightGSL";
import PaintNightDates from "@/views/events/paintNightDates/PaintNightDates";
// import PalisadeFishingReg from "/src/views/events/palisadeFishing/RegisterPage.vue";
// import Waiver from "/src/views/events/palisadeFishing/Waiver.vue";
// import Cart from "/src/views/events/palisadeFishing/AddToCart.vue";
import BirdWatching from "/src/views/events/BirdWatching.vue";
import BirdWatchingMay12 from "/src/views/events/birdwatchDates/May12.vue";
import BirdWatchingMay13 from "/src/views/events/birdwatchDates/May13.vue";
import BirdWatchingMay28 from "/src/views/events/birdwatchDates/May28.vue";
import PioneerGames from "@/views/events/PioneerGames.vue";
import PaddlingWithRanger from "@/views/events/PaddlingWithRanger.vue";
import CampfireStories from "@/views/events/CampfireStories.vue";
import RockportFirewood from "@/views/RockportFirewood.vue";
import JordanWaiver from "@/views/Jordan-OHV/JordanWaiver.vue";
import JordanPurchase from "@/views/Jordan-OHV/JordanPurchase.vue";
import Jordan from "@/views/Jordan-OHV/Jordan.vue";
import NorthBeach from "@/views/YubaCamping/NorthBeaches.vue";
import EagleView from "@/views/YubaCamping/EagleView.vue";
import Oasis from "@/views/YubaCamping/Oasis.vue";
import OasisVista from "@/views/YubaCamping/OasisVista.vue";
import PaintedRock from "@/views/YubaCamping/PaintedRock.vue";
import HobieDry from "@/views/DryStorage/HobieDry.vue"; // rockport storage
import HobieDry2 from "@/views/DryStorage/HobieDry2.vue"; // actual hobie storage
import HobieWaiver from "@/views/DryStorage/HobieWaiver2.vue"; // actual hobie storage
import HobieForm from "@/views/DryStorage/HobieForm.vue"; // rockport storage
import Montecristo from "@/views/Montecristo.vue";
import RockportCamping from "@/views/RockportCamping/RockCamping.vue";
import HyrumCamping from "@/views/HyrumCamping.vue";
import RockportVideo from "@/views/rentals/RockportVideo.vue";
import GunlockDonation from "@/views/events/donations/Gunlock.vue";
import AnasaziDonation from "@/views/events/donations/Anasazi.vue";
import HyrumDonation from "@/views/events/donations/Hyrum.vue";
import DeadHorseDonation from "@/views/events/donations/DeadHorse.vue";
import SandDonations from "@/views/events/donations/SandHollow.vue";
import EastCamping from "../views/EastCanyonCampin/EastCamping.vue";
import Haunted from "../views/EastCanyonCampin/Haunted.vue";
import MoveFromWaitlist from "@/views/events/NewBison/MoveFromWaitlist.vue";
import WillCamping from "@/views/WillardCamping/willCamping.vue";
import AITestSupport from "../views/AITestSupport.vue";
import AiBlocker from "../views/AiBlocker.vue";
// import Permits from "/src/views/events/Permits.vue";
import QuadInfo from "@/views/events/QuadFishathon/QuadInfo.vue";
import QuadWaiver from "@/views/events/QuadFishathon/QuadWaiver.vue";
// import BeachWalk from "../views/events/BeachWalk.vue";
// import BeachWalkMay from "../views/events/beachWalkDates/May.vue";
// import BeachWalkJune from "../views/events/beachWalkDates/June.vue";
// import BeachWalkJuly from "../views/events/beachWalkDates/July.vue";
// import BeachWalkWaiver from "../views/events/beachWalkDates/BeachWalkWaiver.vue";
import RockCliffCamping from "../views/RockCliffCamping/RockCliffCamping.vue";
// rainbow cove camping
import RainbowCove from "../views/BearLakeCamping/RainbowCove.vue";
// south eden camping
import SouthEden from "../views/BearLakeCamping/SouthEden.vue";
import NorthEden from "../views/BearLakeCamping/NorthEden.vue";
import Rendezvous from "../views/BearLakeCamping/RendezvousBeach.vue";
import CiscoBeach from "../views/BearLakeCamping/CiscoBeach.vue";
// Willard Bay Walk In Inlet

import InletWillard from "@/views/InletWillard";
// jordanelle perimeter trail
import JordanelleTrail from "@/views/JordanelleTrail";
// deer creek provo river access
import DeerCreekRiver from "@/views/DeerCreekRiver";

// REGISTER PASS
import Register from "@/views/Register.vue";
import Register2 from "@/views/Register2.vue";
import ManualRegistration from "@/views/ManualRegistration.vue";
import CausewayPass from "@/views/CausewayPass.vue";
import Online from "@/views/RegisterOnline.vue";
import Registeration2026 from "../views/Registeration2026.vue";
import StolenPass from "@/views/StolenPass.vue";
import SnowRegistration from "../views/SnowRegistration.vue";

// Check in pages
import Landing from "@/views/Check-in/Landing.vue";
import Cash from "@/views/Check-in/Cash.vue";
import Annual from "@/views/Check-in/Annual.vue";
import DigitalDay from "@/views/Check-in/DigitalDay.vue";
import Brochure from "@/views/Check-in/Brochure.vue";

//sticker pages
// import StickerLanding from "@/views/StickerPages/StickerLanding.vue";
// import Options from "@/views/StickerPages/Options.vue";
// import Pickup from "@/views/StickerPages/Pickup.vue";
// import Order from "@/views/StickerPages/Order.vue";
// import FromEmail from "@/views/StickerPages/FromEmail.vue";
// import CheckIntoStickerPark from "../views/StickerPages/CheckIntoStickerPark.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);
// Vue.use(vClickOutside)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  {
    path: "/tooltip",
    name: "ToolTip",
    component: ToolTip,
  },
  {
    path: "/stolenpass/:serial_number",
    name: "StolenPass",
    component: StolenPass,
  },
  //   {
  //     path: '/parks/:name',
  //     name: 'Park',
  //     component: Park,
  //   },
  {
    path: "/UTSNOW/registration",
    name: "SnowRegistration",
    component: SnowRegistration,
  },
  {
    path: "/parks/ANNUAL/dayuse",
    redirect: "/parks/PANUAL/dayuse",
  },
  {
    path: "/parks/:name/dayuse",
    name: "ParkDayuse",
    component: ParkDayuse,
  },
  // {
  //   path: "/parks/:name/newdayuse",
  //   name: "ParkDayuse",
  //   component: NewParkDayuse,
  // },
  {
    path: "/parks/:name/camping",
    name: "Camping",
    component: Camping,
  },
  {
    path: "/parks/UTSNOW/info",
    name: "InfoGraphic",
    component: InfoGraphic,
  },
  {
    path: "*",
    name: "PageNotFound",
    component: PageNotFound,
  },
  {
    path: "/plateupdate",
    name: "PlateUpdate",
    component: PlateUpdate,
  },
  {
    path: "/plateupdate/form",
    name: "PlateUpdate2",
    component: PlateUpdate2,
  },
  {
    path: "/checkexpiration",
    name: "CheckExpiration",
    component: CheckExpiration,
  },
  {
    path: "/app/download/:orderid",
    name: "DeepLink",
    component: DeepLink,
  },
  // {
  //   path: "/parks/:name/bisonroundup",
  //   name: "BisonInfo",
  //   component: BisonInfo,
  // },
  // {
  //   path: "/parks/:name/bisonroundup/waiver",
  //   name: "BisonWaiver",
  //   component: BisonWaiver,
  // },
  {
    path: "/parks/:name/bisonroundup/thankyou",
    name: "Thankyou",
    component: Thankyou,
  },
  {
    path: "/parks/:name/bisonroundup/movefromwaitlist/:uuid/:quantity",
    name: "MoveFromWaitlist",
    component: MoveFromWaitlist,
  },
  {
    path: "/parks/:name/bisonroundup/waitlist",
    name: "BisonWaitlist",
    component: BisonWaitlist,
  },
  {
    path: "/parks/:name/fantasyatthebay",
    name: "FantasyAtTheBay",
    component: FantasyAtTheBay,
  },
  {
    path: "/parks/:name/fantasyatthebay/:month/:day",
    name: "fantasyDates",
    component: FantasyDates,
  },
  {
    path: "/parks/:name/3dglasses",
    name: "3dGlasses",
    component: dGlasses,
  },
  {
    path: "/parks/:name/fishingchallenge",
    name: "FishingChallenge",
    component: FishingChallenge,
  },
  {
    path: "/parks/:name/quailtriathlon",
    name: "QuailTriathlon",
    component: QuailTriathlon,
  },
  {
    path: "/parks/:name/discgolf",
    name: "DiscGolf",
    component: DiscGolf,
  },
  // {
  //   path: "/parks/:name/moonwalk",
  //   name: "MoonWalk",
  //   component: MoonWalk,
  // },
  // {
  //   path: "/parks/:name/carshow",
  //   name: "CarShow",
  //   component: CarShow,
  // },
  // {
  //   path: "/parks/:name/carshow/waiver/:id",
  //   name: "CarShowWaiver",
  //   component: CarShowWaiver,
  // },
  {
    path: "/parks/:name/starvationspecies",
    name: "StarvationSpecies",
    component: StarvationSpecies,
  },
  {
    path: "/parks/:name/starvationspecies/waiver/:id",
    name: "StarvationSpeciesWaiver",
    component: StarvationSpeciesWaiver,
  },
  {
    path: "/parks/:name/moonlit",
    name: "Moonlit",
    component: Moonlit,
  },
  {
    path: "/parks/:name/moonlit/waiver/:id",
    name: "MoonlitWaiver",
    component: MoonlitWaiver,
  },
  // {
  //   path: "/parks/:name/moonwalk/june",
  //   name: "MoonWalkJune",
  //   component: MoonWalkJune,
  // },
  // {
  //   path: "/parks/:name/moonwalk/july",
  //   name: "MoonWalkJuly",
  //   component: MoonWalkJuly,
  // },
  // {
  //   path: "/parks/:name/moonwalk/august",
  //   name: "MoonWalkAugust",
  //   component: MoonWalkAugust,
  // },
  // {
  //   path: "/parks/:name/moonwalk/september",
  //   name: "MoonWalkSeptember",
  //   component: MoonWalkSeptember,
  // },
  // {
  //   path: "/parks/:name/moonwalk/october",
  //   name: "MoonWalkOctober",
  //   component: MoonWalkOctober,
  // },
  // {
  //   path: "/parks/:park/moonwalk/waiver/:id",
  //   name: "MoonWalkWaiver",
  //   component: MoonWalkWaiver,
  // },
  {
    path: "/parks/:name/groupfire/oct7th",
    name: "GroupFireOct7th",
    component: GroupFireOct7,
  },
  {
    path: "/parks/:name/groupfire/oct20th",
    name: "GroupFireOct20th",
    component: GroupFireOct20,
  },
  {
    path: "/parks/:name/groupfire/oct27th",
    name: "GroupFireOct27th",
    component: GroupFireOct27,
  },
  {
    path: "/parks/:name/campfire",
    name: "CampfireStories",
    component: CampfireStories,
  },
  {
    path: "/parks/:name/pioneergames",
    name: "PioneerGames",
    component: PioneerGames,
  },
  {
    path: "/parks/:name/paddlingwithranger",
    name: "PaddlingWithRanger",
    component: PaddlingWithRanger,
  },
  {
    path: "/brad",
    name: "Brad",
    component: Brad,
  },
  {
    path: "/parks/:name/hike",
    name: "HikeGSL",
    component: HikeGSL,
  },
  {
    path: "/app",
    name: "Store",
    component: Store,
  },
  {
    path: "/parks/:name/mirabilite",
    name: "Mirabilite",
    component: Mirabilite2023,
  },
  {
    path: "/parks/:name/mirabilite/:dates",
    name: "Mirabilite Dates",
    component: MirabileiteDates,
  },
  {
    path: "/parks/:name/mirabilite/jan11",
    name: "MirabiliteJan14",
    component: MirabiliteJan14,
  },
  {
    path: "/parks/:name/mirabilite/jan12",
    name: "MirabiliteJan15",
    component: MirabiliteJan15,
  },
  {
    path: "/parks/:name/mirabilite/jan18",
    name: "MirabiliteJan16",
    component: MirabiliteJan16,
  },
  {
    path: "/parks/:name/mirabilite/jan19",
    name: "MirabiliteJan21",
    component: MirabiliteJan21,
  },
  {
    path: "/parks/:name/mirabilite/jan20",
    name: "MirabiliteJan22",
    component: MirabiliteJan22,
  },
  {
    path: "/parks/:name/Eggstravaganza",
    name: "Eggstrav",
    component: Eggstrav,
  },
  {
    path: "/parks/:name/prehistoric",
    name: "prehistoric",
    component: Prehistoric,
  },
  {
    path: "/parks/:name/paintnight",
    name: "PaintNight",
    component: PaintNight,
  },
  {
    path: "/parks/:name/paintnight/:type/:month/:day",
    name: "paintNightDate",
    component: PaintNightDates,
  },
  // {
  //   path: "/parks/:name/palisadefishingreg",
  //   name: "PalisadeFishingReg",
  //   component: PalisadeFishingReg,
  //   props: true,
  // },
  // {
  //   path: "/parks/:name/waiver",
  //   name: "Waiver",
  //   component: Waiver,
  // },
  // {
  //   path: "/parks/:name/fishingcart",
  //   name: "FishingCart",
  //   component: Cart,
  // },
  {
    path: "/parks/:name/birdwatching/may12",
    name: "BirdWatchingMay12",
    component: BirdWatchingMay12,
  },
  {
    path: "/parks/:name/birdwatching/may13",
    name: "BirdWatchingMay13",
    component: BirdWatchingMay13,
  },
  {
    path: "/parks/:name/birdwatching/may28",
    name: "BirdWatchingMay28",
    component: BirdWatchingMay28,
  },
  // {
  //   path: "/parks/:name/fishingcart",
  //   name: "FishingCart",
  //   component: Cart,
  // },
  {
    path: "/parks/:name/dayuse/inlet",
    name: "InletWillard",
    component: InletWillard,
  },
  {
    path: "/parks/:name/dayuse/jordanelletrail",
    name: "JordanelleTrail",
    component: JordanelleTrail,
  },
  {
    path: "/parks/UTDEER/dayuse/river",
    name: "DeerCreekRiver",
    component: DeerCreekRiver,
  },
  {
    path: "/parks/UTGREA/birdwatching",
    name: "BirdWatching",
    component: BirdWatching,
  },
  {
    path: "/parks/:name/rockportfirewood",
    name: "RockportFirewood",
    component: RockportFirewood,
  },
  {
    path: "/parks/UTJOHV/jordan/waiver",
    name: "JordanWaiver",
    component: JordanWaiver,
  },
  {
    path: "/parks/UTJOHV/jordan/purchase",
    name: "JordanPurchase",
    component: JordanPurchase,
  },
  {
    path: "/parks/UTJOHV/jordan",
    name: "Jordan",
    component: Jordan,
  },
  {
    path: "/parks/UTYUBA/camping/northbeach",
    name: "NorthBeach",
    component: NorthBeach,
  },
  {
    path: "/parks/UTYUBA/camping/eagleview",
    name: "EagleView",
    component: EagleView,
  },
  {
    path: "/parks/UTYUBA/camping/oasis",
    name: "Oasis",
    component: Oasis,
  },
  {
    path: "/parks/UTYUBA/camping/oasisvista",
    name: "OasisVista",
    component: OasisVista,
  },
  {
    path: "/parks/UTYUBA/camping/paintedrock",
    name: "PaintedRock",
    component: PaintedRock,
  },
  {
    path: "/parks/UTROCK/camping/riverside",
    name: "RockportCamping",
    component: RockportCamping,
  },
  {
    path: "/parks/UTHYRU/hyrumcamping",
    name: "HyrumCamping",
    component: HyrumCamping,
  },
  {
    path: "/parks/UTEAST/camping/east",
    name: "EastCamping",
    component: EastCamping,
  },
  {
    path: "/parks/UTEAST/camping/haunted",
    name: "HauntedCamping",
    component: Haunted,
  },
  {
    path: "/parks/UTROCK/drystorage/rockport",
    name: "HobieDry",
    component: HobieDry,
  },
  {
    path: "/parks/UTROCK/drystorage/hobie",
    name: "HobieDry2",
    component: HobieDry2,
  },
  {
    path: "/parks/UTROCK/drystorage/hobieform",
    name: "HobieWaiver",
    component: HobieWaiver,
  },
  {
    path: "/parks/UTROCK/drystorage/rockportform",
    name: "HobieForm",
    component: HobieForm,
  },
  {
    path: "/parks/UTWILL/montecristo/dayuse",
    name: "Montecristo",
    component: Montecristo,
  },

  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/activate/:id",
    name: "Register",
    component: Register2,
  },
  {
    path: "/activate26/:id",
    name: "Registeration2026",
    component: Registeration2026,
  },
  {
    path: "/activate/online/:id",
    name: "Online",
    component: Online,
  },
  {
    path: "/manual-registration",
    name: "Manual Register",
    component: ManualRegistration,
  },
  {
    path: "/causeway",
    name: "Causeway Pass Registration",
    component: CausewayPass,
  },
  {
    path: "/:park/checkin",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/:park/checkin/cash",
    name: "Cash",
    component: Cash,
  },
  {
    path: "/:park/checkin/annual",
    name: "Annual",
    component: Annual,
  },
  {
    path: "/:park/checkin/digitalday",
    name: "DigitalDay",
    component: DigitalDay,
  },
  {
    path: "/:park/checkin/brochure",
    name: "Brochure",
    component: Brochure,
  },
  {
    path: "/:park/checkin/error",
    name: "Error",
    component: Error,
  },
  {
    path: "/parks/UTROCK/rockportvideo",
    name: "RockportVideo",
    component: RockportVideo,
  },
  {
    path: "/parks/UTGUNL/donations",
    name: "GunlockDonation",
    component: GunlockDonation,
  },
  {
    path: "/parks/UTSAND/donations",
    name: "SandDonations",
    component: SandDonations,
  },
  {
    path: "/parks/UTANAS/donations",
    name: "AnasaziDonation",
    component: AnasaziDonation,
  },
  {
    path: "/parks/UTHYRU/donations",
    name: "HyrumDonation",
    component: HyrumDonation,
  },
  {
    path: "/parks/UTDEAD/donations",
    name: "DeadHorseDonation",
    component: DeadHorseDonation,
  },
  {
    path: "/parks/UTWILL/camping/offseason",
    name: "WillCamping",
    component: WillCamping,
  },
  {
    path: "/passhelp",
    name: "PassHelp",
    component: PassHelp,
  },
  // {
  //   path: "/passhelp/stickerlanding",
  //   name: "StickerLanding",
  //   component: StickerLanding,
  // },
  // {
  //   path: "/passhelp/options",
  //   name: "Options",
  //   component: Options,
  // },
  // {
  //   path: "/passhelp/pickup",
  //   name: "Pickup",
  //   component: Pickup,
  // },
  // {
  //   path: "/passhelp/order",
  //   name: "Order",
  //   component: Order,
  // },
  // {
  //   path: "/passhelp/online/:ordernumber",
  //   name: "FromEmail",
  //   component: FromEmail,
  // },
  // {
  //   path: "/sticker/pickedup/:ordernumber",
  //   name: "CheckIntoStickerPark",
  //   component: CheckIntoStickerPark,
  // },
  {
    path: "/aisupport/access",
    name: "AITestSupport",
    component: AITestSupport,
  },
  {
    path: "/aisupport",
    name: "AiBlocker",
    component: AiBlocker,
  },
  {
    path: "/parks/quadfishathon/info",
    name: "QuadInfo",
    component: QuadInfo,
  },
  {
    path: "/parks/quadfishathon/waivers/:quantity",
    name: "QuadWaiver",
    component: QuadWaiver,
  },
  // {
  //   path: "/parks/:park/beachwalk",
  //   name: "BeachWalk",
  //   component: BeachWalk,
  // },
  // {
  //   path: "/parks/:park/beachwalk/may",
  //   name: "BeachWalkMay",
  //   component: BeachWalkMay,
  // },
  // {
  //   path: "/parks/:park/beachwalk/june",
  //   name: "BeachWalkJune",
  //   component: BeachWalkJune,
  // },
  // {
  //   path: "/parks/:park/beachwalk/july",
  //   name: "BeachWalkJuly",
  //   component: BeachWalkJuly,
  // },
  // {
  //   path: "/parks/:park/beachwalk/waiver/:id",
  //   name: "BeachWalkWaiver",
  //   component: BeachWalkWaiver,
  // },
  {
    path: "/parks/UTJORD/camping/rockcliff",
    name: "RockCliffCamping",
    component: RockCliffCamping,
  },
  {
    path: "/parks/UTBEAR/camping/rainbowcove",
    name: "RainbowCove",
    component: RainbowCove,
  },
  {
    path: "/parks/UTBEAR/camping/southeden",
    name: "SouthEden",
    component: SouthEden,
  },
  {
    path: "/parks/UTBEAR/camping/northeden",
    name: "NorthEden",
    component: NorthEden,
  },
  {
    path: "/parks/UTBEAR/camping/ciscobeach",
    name: "CiscoBeach",
    component: CiscoBeach,
  },
  {
    path: "/parks/UTBEAR/camping/rendezvous",
    name: "Rendezvous",
    component: Rendezvous,
  },

  // {
  //   path: "/permits",
  //   name: "Permits",
  //   component: Permits,
  // },
  // REDIRECTS
  // { path: "/bisonroundup", redirect: "/parks/UTANTE/bisonroundup" },
  {
    path: "/bisonroundup",
    beforeEnter() {
      window.location.href =
        "https://events.parkspass.app/events/bison-roundup-2026-mrnz9id7";
    },
  },
  {
    path: "/parks/UTANTE/bisonroundup",
    beforeEnter: () => {
      window.location.replace(
        "https://events.parkspass.app/events/bison-roundup-2026-mrnz9id7"
      );
    },
  },
  { path: "/fishingchallenge", redirect: "/parks/UTEAST/fishingchallenge" },
  { path: "/quailtriathlon", redirect: "/parks/UTQUIA/quailtriathlon" },
  { path: "/groupfire", redirect: "/parks/UTGREA/groupfire" },
  { path: "/groupfireoct7", redirect: "/parks/UTGREA/groupfire/oct7th" },
  { path: "/palisadefishing", redirect: "/parks/:name/palisadefishingreg" },

  // Redirects for the new signs
  { path: "/parks/utahraptor", redirect: "/parks/UTRAPT/camping" },
  { path: "/parks/anasazi", redirect: "/parks/UTANAS/dayuse" },
  { path: "/parks/antelope", redirect: "/parks/UTANTE/dayuse" },
  { path: "/parks/bear", redirect: "/parks/UTBEAR/dayuse" },
  { path: "/parks/floyd", redirect: "/parks/UTCAMP/dayuse" },
  { path: "/parks/coral", redirect: "/parks/UTCORA/dayuse" },
  { path: "/parks/deadhorse", redirect: "/parks/UTDEAD/dayuse" },
  { path: "/parks/deer", redirect: "/parks/UTDEER/dayuse" },
  { path: "/parks/east", redirect: "/parks/UTEAST/dayuse" },
  { path: "/parks/echo", redirect: "/parks/UTECHO/dayuse" },
  { path: "/parks/cedars", redirect: "/parks/UTEDGE/dayuse" },
  { path: "/parks/escalante", redirect: "/parks/UTESCA/dayuse" },
  { path: "/parks/flight", redirect: "/parks/UTFLIG/dayuse" },
  { path: "/parks/starvation", redirect: "/parks/UTFRED/dayuse" },
  { path: "/parks/fremont", redirect: "/parks/UTFREM/dayuse" },
  { path: "/parks/frontier", redirect: "/parks/UTFRON/dayuse" },
  { path: "/parks/goblin", redirect: "/parks/UTGOBL/dayuse" },
  { path: "/parks/goosenecks", redirect: "/parks/UTGOOS/dayuse" },
  { path: "/parks/great", redirect: "/parks/UTGREA/dayuse" },
  { path: "/parks/green", redirect: "/parks/UTGREE/dayuse" },
  { path: "/parks/gunlock", redirect: "/parks/UTGUNL/dayuse" },
  { path: "/parks/huntington", redirect: "/parks/UTHUNT/dayuse" },
  { path: "/parks/hyrum", redirect: "/parks/UTHYRU/dayuse" },
  { path: "/parks/jordan", redirect: "/parks/UTJOHV/dayuse" },
  { path: "/parks/jordanelle", redirect: "/parks/UTJORD/dayuse" },
  { path: "/parks/kodachrome", redirect: "/parks/UTKODA/dayuse" },
  { path: "/parks/lost", redirect: "/parks/UTLOST/dayuse" },
  { path: "/parks/millsite", redirect: "/parks/UTMILL/dayuse" },
  { path: "/parks/otter", redirect: "/parks/UTOTTE/dayuse" },
  { path: "/parks/palisade", redirect: "/parks/UTPALI/dayuse" },
  { path: "/parks/piute", redirect: "/parks/UTPIUT/dayuse" },
  { path: "/parks/quail", redirect: "/parks/UTQUIA/dayuse" },
  { path: "/parks/red", redirect: "/parks/UTREDF/dayuse" },
  { path: "/parks/rockport", redirect: "/parks/UTROCK/dayuse" },
  { path: "/parks/sand", redirect: "/parks/UTSAND/dayuse" },
  { path: "/parks/scofield", redirect: "/parks/UTSCOF/dayuse" },
  { path: "/parks/snow", redirect: "/parks/UTSNOW/dayuse" },
  { path: "/parks/steinaker", redirect: "/parks/UTSTEI/dayuse" },
  { path: "/parks/territorial", redirect: "/parks/UTTERR/dayuse" },
  { path: "/parks/fieldhouse", redirect: "/parks/UTFHNH/dayuse" },
  { path: "/parks/utahlake", redirect: "/parks/UTULSP/dayuse" },
  { path: "/parks/wasatch", redirect: "/parks/UTWASA/dayuse" },
  { path: "/parks/willard", redirect: "/parks/UTWILL/dayuse" },
  { path: "/parks/yuba", redirect: "/parks/UTYUBA/dayuse" },

  /// camping
  { path: "/camping/rockcliff", redirect: "/parks/UTJORD/camping/rockcliff" },
];

// Redirects for the new signs
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Track if this is the initial page load
let isInitialLoad = true;

// Focus management and announcement for screen readers
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // Update page title
    if (!document.title.includes("ParksPass")) {
      document.title = to.name
        ? `${to.name} - Utah State Parks`
        : "Utah State Parks";
    }

    // Only manage focus on actual navigation, not initial page load
    if (!isInitialLoad && from.name) {
      // Focus management - but prevent scrolling
      const mainContent =
        document.querySelector("#main-content") ||
        document.querySelector("main");

      if (mainContent) {
        if (!mainContent.hasAttribute("tabindex")) {
          mainContent.setAttribute("tabindex", "-1");
        }

        mainContent.focus({ preventScroll: true });
        mainContent.style.outline = "none";
      } else {
        // Fallback: focus on first heading
        const h1 = document.querySelector("h1");
        if (h1) {
          if (!h1.hasAttribute("tabindex")) {
            h1.setAttribute("tabindex", "-1");
          }
          h1.focus({ preventScroll: true });
          h1.style.outline = "none";
        }
      }

      // Announce route change to screen readers
      announceRouteChange(to);
    }

    // After first navigation, all subsequent ones are not initial loads
    isInitialLoad = false;
  });
});

// Helper function remains the same
function announceRouteChange(route) {
  const announcement = route.meta?.announcement || route.name || "Page changed";

  let liveRegion = document.querySelector("#route-announcer");

  if (!liveRegion) {
    liveRegion = document.createElement("div");
    liveRegion.id = "route-announcer";
    liveRegion.setAttribute("aria-live", "polite");
    liveRegion.setAttribute("aria-atomic", "true");
    liveRegion.className = "sr-only";
    document.body.appendChild(liveRegion);
  }

  liveRegion.textContent = "";
  setTimeout(() => {
    liveRegion.textContent = `Navigated to ${announcement}`;
  }, 100);
}

export default router;
